import React, { useEffect, useRef } from "react";
import { art } from "./config";

// Words light up one by one as the paragraph scrolls through the viewport.
const LINES = [
  ["Most", "maths", "apps", "ask", "your", "child", "questions."],
  ["I", "ask", "for", "*help."],
  ["Because", "a", "child", "who", "can", "explain", "it"],
  ["really", "*gets", "*it."],
];

export default function Statement() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const words = Array.from(el.querySelectorAll(".w"));
    let raf = 0;
    const update = () => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      // 0 when the top of the block reaches 85% of the viewport, 1 when its bottom reaches 45%.
      const start = vh * 0.85;
      const end = vh * 0.45;
      const p = Math.min(1, Math.max(0, (start - r.top) / (start - end + r.height)));
      const lit = Math.round(p * words.length);
      words.forEach((w, n) => w.classList.toggle("is-lit", n < lit));
    };
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <section className="statement" data-testid="statement-section">
      <div className="wrap statement-grid">
        <p ref={ref}>
          {LINES.map((line, l) => (
            <React.Fragment key={l}>
              {line.map((w, n) => {
                const accent = w.startsWith("*");
                return (
                  <React.Fragment key={n}>
                    <span className={`w ${accent ? "said" : ""}`}>{accent ? w.slice(1) : w}</span>{" "}
                  </React.Fragment>
                );
              })}
              {l === 1 && <br />}
            </React.Fragment>
          ))}
        </p>
        <div className="statement-art rv">
          <span className="thought">hmm…</span>
          <img src={art("leo-thinking.png")} alt="Leo, finger on his chin, thinking" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
